const bc = new BroadcastChannel("open-tabs");

type OpenTabsMessage =
    | {
          type: "ping";
      }
    | {
          type: "pong";
      };

let pongCount = 0;

bc.onmessage = (event: MessageEvent<OpenTabsMessage>) => {
    if (event.data.type === "ping") {
        bc.postMessage({ type: "pong" });
    } else if (event.data.type === "pong") {
        pongCount++;
    }
};

export async function getOpenTabsCount() {
    const startPongCount = pongCount;
    bc.postMessage({ type: "ping" });
    await new Promise((resolve) => setTimeout(resolve, 100));
    return 1 + (pongCount - startPongCount);
}
